import { FULL_ROUTES } from './FULL';

export const ROUTE_GROUPS = {
	APP: [
		FULL_ROUTES.DASHBOARD,
		FULL_ROUTES.INITIATIVES,
		FULL_ROUTES.ISSUES,
		FULL_ROUTES.PERISCOPE,
		FULL_ROUTES.SETTINGS,
		FULL_ROUTES.SYNC,
		FULL_ROUTES.TAGS,
		FULL_ROUTES.TIMELINE
	],
	DASHBOARD: [
		FULL_ROUTES.DASHBOARD,
		FULL_ROUTES.EXPORT
	],
	INITIATIVES: [
		FULL_ROUTES.INITIATIVES,
		FULL_ROUTES.INITIATIVES_DETAIL
	],
	ONBOARDING: [
		FULL_ROUTES.ONBOARDING_CONFIRM,
		FULL_ROUTES.ONBOARDING_CONNECT,
		FULL_ROUTES.ONBOARDING_SYNC
	],
	SETTINGS: [
		FULL_ROUTES.SETTINGS,
		FULL_ROUTES.SETTINGS_INTEGRATIONS,
		FULL_ROUTES.SETTINGS_ORGANIZATION,
		FULL_ROUTES.SETTINGS_TEAM,
		FULL_ROUTES.SETTINGS_USER
	]
};
